@import '../../utils/global.module.less';

@keyframes contentFlash {
    0% {
        background-color: #f1efe9;
    }
    20% {
        background-color: rgba(16, 36, 66, 0.4); /* Subtle highlight tint */
    }
    100% {
        background-color: #f1efe9;
    }
}

.sideChatNoSelection {
    filter: grayscale(100%) opacity(50%);
    cursor: not-allowed !important;
}

.sideChatLabelHighlight {
    animation: contentFlash 0.8s ease-in-out;
}

.sideChatContainer {
    position: absolute;
    right: 10px;
    bottom: 0px;
    width: 600px;
    z-index: 100;
    background-color: white;
    border-radius: 15px 15px 0px 0px;
    transition: height 0.48s cubic-bezier(0.67, -0.37, 0.64, 1.42);
    height: 64px;
    .shadow();
}

.sideChatContainerMaximized {
    height: 450px !important;
}

.messagesContainer {
    width: 100%;
    gap: 18px;
    min-height: 100%;
}

.headerContainer {
    height: 56px;
    width: 100%;
    margin-bottom: 8px;
}

//HEADER
.title {
    color: red;
}

.header {
    padding: 6px 16px;
    align-items: center !important;
    gap: 10px;
    border-bottom: 2px dashed #f1efe9;

    &_title {
        font-family: LustTextItalic;
        margin-right: 20px;
        font-size: 20px;
        font-weight: 500;
        color: #102442;
    }

    &_contextType {
        background-color: rgb(249, 247, 242);
        border: 2px solid rgb(241, 239, 233);
        border-radius: 20px;
        padding: 1px 8px 1px 8px;
        margin-right: 2px;
    }

    &_breadcrumb {
        display: flex;
        height: 100%;
        font-family: Hanken Grotesk;
        font-size: 16px;

        flex: 1;
        background-color: #f1efe9;
        border-radius: 20px;
        height: 34px;
        padding: 0px 0px 0px 15px;
        align-items: center;
        color: #2075f4;
    }

    &_min_max_button {
        width: 24px;
        height: 24px;
        & > img {
            width: 24px;
            height: 24px;
        }
        margin-left: 16px;
        font-family: LustTextMedium;
        &:hover {
            cursor: pointer;
            .filterBlue();
        }
    }
    &_expand {
        align-self: center;
        width: 16px;
        height: 16px;
    }
}

.scrollContainer {
    font-family: Hanken Grotesk;
    font-size: 14px;
}

.input {
    margin-top: 5px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 4px;
    &_container {
        border: 1px solid #e3e6eb;
        border-radius: 10px;
        width: calc(92%);
        background-color: #fcfcfd;
        &:focus-within {
            border: 1px solid #2075f4;
            outline: #2075f4;
            & .input_chat_arrow {
                .filterBlue();
            }
        }
        margin-bottom: 4px;
    }

    &_textbox {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;

        & > textarea {
            font-family: Hanken Grotesk;
            margin-left: 6px;
            width: 100%;
            background-color: transparent;
            border: 0 !important;
            border-color: transparent;
            outline: none;
        }
    }

    &_chat_arrow {
        display: flex;
        justify-content: center;
        align-items: end;

        &:hover {
            cursor: pointer;
        }

        & > img {
            width: 20px;
            height: 20px;
            margin-right: 6px;
            margin-bottom: 9px;
        }
    }

    &_chat_arrow_disabled {
        cursor: wait !important;
    }
}

.fake_textarea {
    width: 100%;
    min-height: 40px;
    max-height: 300px;
    overflow-y: auto;
    border: 1px solid #ccc;
    padding: 8px;
    border-radius: 8px;

    /* Crucial for handling pasted code or strict line breaks correctly */
    white-space: pre-wrap;
    word-break: break-word;
    outline: none;
    border: none;
}

.fake_textarea:empty::before {
    content: attr(placeholder);
    color: #aaa;
    cursor: text;
}
